/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { IBuyboxConfig, IBuyboxData, IBuyboxFindInStoreViewProps, IBuyboxProps, IBuyboxResources } from './modules/buybox';
import Buybox, { IBuyboxViewProps } from './modules/buybox/buybox';
import BuyboxView from './modules/buybox/buybox.view';
import QuickView, { IQuickviewViewProps } from './modules/quickview/quickview';
import { IQuickviewData } from './modules/quickview/quickview.data';
import { IQuickviewConfig, IQuickviewProps, IQuickviewResources } from './modules/quickview/quickview.props.autogenerated';
import QuickViewFunctionalComponent from './modules/quickview/quickview.view';

export * from './common';

export {
    Buybox,
    BuyboxView,
    IBuyboxConfig,
    IBuyboxData,
    IBuyboxFindInStoreViewProps,
    IBuyboxProps,
    IBuyboxResources,
    IBuyboxViewProps,
    IQuickviewConfig,
    IQuickviewData,
    IQuickviewProps,
    IQuickviewResources,
    IQuickviewViewProps,
    QuickView,
    QuickViewFunctionalComponent
};
